import React from "react";
import ReactDOM from "react-dom/client";
import { App as AntdApp, ConfigProvider } from "antd";
import ruRU from "antd/locale/ru_RU";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
// Порядок важен: токены → глобальные стили → словарь mk-*.
import "./design/fonts.css";
import "./design/tokens.css";
import "./ui.css";
import "./marketing/marketing.css";
import "./design/studio.css";
import "./design/fishka.css";

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

const router = createBrowserRouter([
  {
    path: "*",
    element: (
      // maxCount ограничивает стопку тостов: больше трёх плашек на экране не копится.
      <AntdApp message={{ maxCount: 3 }}>
        <App />
      </AntdApp>
    ),
  },
]);

// Единый оранжевый фокус светлой темы FISHKA.
const FOCUS_SHADOW = "0 0 0 3px rgba(255,105,0,.35)";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={ruRU}
      theme={{
        token: {
          colorPrimary: "#FF6900",
          colorLink: "#FF6900",
          colorInfo: "#0096FF",
          colorSuccess: "#7CB342",
          colorWarning: "#FB8C00",
          colorError: "#E53935",
          borderRadius: 6,
          borderRadiusLG: 8,
          fontFamily:
            "'FK Emoji', 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Apple Color Emoji', 'Noto Color Emoji', sans-serif",
          fontSize: 15,
          colorText: "#1A1F36",
          colorTextSecondary: "#5B6178",
          colorBorder: "#C8CCD8",
          colorBorderSecondary: "#E5E8F0",
          colorBgLayout: "#FAFBFD",
        },
        components: {
          Input: {
            activeBorderColor: "#FF6900",
            hoverBorderColor: "#FF6900",
            activeShadow: FOCUS_SHADOW,
          },
          InputNumber: {
            activeBorderColor: "#FF6900",
            hoverBorderColor: "#FF6900",
            activeShadow: FOCUS_SHADOW,
          },
          Select: {
            activeBorderColor: "#FF6900",
            hoverBorderColor: "#FF6900",
            activeOutlineColor: "rgba(255,105,0,.25)",
          },
          DatePicker: {
            activeBorderColor: "#FF6900",
            hoverBorderColor: "#FF6900",
            activeShadow: FOCUS_SHADOW,
          },
          Table: {
            headerBg: "#FAFAFA",
            headerColor: "#5B6178",
            rowHoverBg: "rgba(0,0,0,.025)",
            cellFontSize: 13,
          },
          Modal: { borderRadiusLG: 8, titleFontSize: 18 },
          // antd 6 кладёт текст тоста в .ant-message-notice-title, а его красит colorTextHeading — без него текст тёмный на тёмном.
          Message: {
            contentBg: "#251D4A",
            colorText: "#fff",
            colorTextHeading: "#fff",
            colorIcon: "#fff",
            colorSuccess: "#fff",
            colorError: "#F8B67B",
            colorInfo: "#fff",
            borderRadiusLG: 8,
          },
        },
      }}
    >
      <QueryClientProvider client={qc}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
